"use strict";
var $a5fd07fa01589658$exports = {};
"use strict";
const $a5fd07fa01589658$var$BOARD_SIZE = 4;
const $a5fd07fa01589658$var$WIN_VALUE = 2048;
function $a5fd07fa01589658$var$createEmptyState() {
    return Array.from({
        length: $a5fd07fa01589658$var$BOARD_SIZE
    }, ()=>Array($a5fd07fa01589658$var$BOARD_SIZE).fill(0));
}
function $a5fd07fa01589658$var$cloneState(state) {
    return state.map((row)=>[
            ...row
        ]);
}
function $a5fd07fa01589658$var$transpose(state) {
    const result = $a5fd07fa01589658$var$createEmptyState();
    for(let row = 0; row < $a5fd07fa01589658$var$BOARD_SIZE; row += 1)for(let col = 0; col < $a5fd07fa01589658$var$BOARD_SIZE; col += 1)result[col][row] = state[row][col];
    return result;
}
function $a5fd07fa01589658$var$reverseRows(state) {
    return state.map((row)=>[
            ...row
        ].reverse());
}
class $a5fd07fa01589658$var$Game {
    /**
   * @param {number[][]} initialState
   */ constructor(initialState = $a5fd07fa01589658$var$createEmptyState()){
        this.initialState = $a5fd07fa01589658$var$cloneState(initialState);
        this.state = $a5fd07fa01589658$var$cloneState(initialState);
        this.score = 0;
        this.status = "idle";
    }
    moveLeft() {
        this.makeMove("left");
    }
    moveRight() {
        this.makeMove("right");
    }
    moveUp() {
        this.makeMove("up");
    }
    moveDown() {
        this.makeMove("down");
    }
    /**
   * @returns {number}
   */ getScore() {
        return this.score;
    }
    /**
   * @returns {number[][]}
   */ getState() {
        return $a5fd07fa01589658$var$cloneState(this.state);
    }
    /**
   * @returns {string}
   */ getStatus() {
        return this.status;
    }
    start() {
        if (this.status !== "idle") return;
        this.addRandomCell();
        this.addRandomCell();
        this.updateStatus();
    }
    restart() {
        this.state = $a5fd07fa01589658$var$cloneState(this.initialState);
        this.score = 0;
        this.status = "idle";
    }
    makeMove(direction) {
        if (this.status !== "playing") return;
        const { nextState: nextState, gainedScore: gainedScore } = this.getMovedState(direction);
        if (this.isSameState(this.state, nextState)) return;
        this.state = nextState;
        this.score += gainedScore;
        this.addRandomCell();
        this.updateStatus();
    }
    getMovedState(direction) {
        switch(direction){
            case "left":
                return this.moveStateLeft(this.state);
            case "right":
                return this.moveStateRight(this.state);
            case "up":
                return this.moveStateUp(this.state);
            case "down":
                return this.moveStateDown(this.state);
            default:
                return {
                    nextState: $a5fd07fa01589658$var$cloneState(this.state),
                    gainedScore: 0
                };
        }
    }
    moveStateLeft(state) {
        const nextState = [];
        let gainedScore = 0;
        for (const row of state){
            const processed = this.processLine(row);
            nextState.push(processed.line);
            gainedScore += processed.gainedScore;
        }
        return {
            nextState: nextState,
            gainedScore: gainedScore
        };
    }
    moveStateRight(state) {
        const reversed = $a5fd07fa01589658$var$reverseRows(state);
        const moved = this.moveStateLeft(reversed);
        return {
            nextState: $a5fd07fa01589658$var$reverseRows(moved.nextState),
            gainedScore: moved.gainedScore
        };
    }
    moveStateUp(state) {
        const transposed = $a5fd07fa01589658$var$transpose(state);
        const moved = this.moveStateLeft(transposed);
        return {
            nextState: $a5fd07fa01589658$var$transpose(moved.nextState),
            gainedScore: moved.gainedScore
        };
    }
    moveStateDown(state) {
        const transposed = $a5fd07fa01589658$var$transpose(state);
        const moved = this.moveStateRight(transposed);
        return {
            nextState: $a5fd07fa01589658$var$transpose(moved.nextState),
            gainedScore: moved.gainedScore
        };
    }
    processLine(line) {
        const filtered = line.filter((value)=>value !== 0);
        const merged = [];
        let gainedScore = 0;
        for(let i = 0; i < filtered.length; i += 1){
            const current = filtered[i];
            const next = filtered[i + 1];
            if (current === next) {
                const mergedValue = current * 2;
                merged.push(mergedValue);
                gainedScore += mergedValue;
                i += 1;
            } else merged.push(current);
        }
        while(merged.length < $a5fd07fa01589658$var$BOARD_SIZE)merged.push(0);
        return {
            line: merged,
            gainedScore: gainedScore
        };
    }
    addRandomCell() {
        const emptyCells = [];
        for(let rowIndex = 0; rowIndex < $a5fd07fa01589658$var$BOARD_SIZE; rowIndex += 1){
            for(let colIndex = 0; colIndex < $a5fd07fa01589658$var$BOARD_SIZE; colIndex += 1)if (this.state[rowIndex][colIndex] === 0) emptyCells.push([
                rowIndex,
                colIndex
            ]);
        }
        if (emptyCells.length === 0) return;
        const randomIndex = Math.floor(Math.random() * emptyCells.length);
        const [targetRow, targetCol] = emptyCells[randomIndex];
        this.state[targetRow][targetCol] = Math.random() < 0.1 ? 4 : 2;
    }
    updateStatus() {
        if (this.hasWinningCell()) {
            this.status = "win";
            return;
        }
        if (this.hasAvailableMoves()) {
            this.status = "playing";
            return;
        }
        this.status = "lose";
    }
    hasWinningCell() {
        return this.state.some((row)=>row.some((cell)=>cell >= $a5fd07fa01589658$var$WIN_VALUE));
    }
    hasAvailableMoves() {
        for(let row = 0; row < $a5fd07fa01589658$var$BOARD_SIZE; row += 1)for(let col = 0; col < $a5fd07fa01589658$var$BOARD_SIZE; col += 1){
            const current = this.state[row][col];
            if (current === 0) return true;
            const right = col < $a5fd07fa01589658$var$BOARD_SIZE - 1 ? this.state[row][col + 1] : null;
            const down = row < $a5fd07fa01589658$var$BOARD_SIZE - 1 ? this.state[row + 1][col] : null;
            if (current === right || current === down) return true;
        }
        return false;
    }
    isSameState(firstState, secondState) {
        for(let row = 0; row < $a5fd07fa01589658$var$BOARD_SIZE; row += 1)for(let col = 0; col < $a5fd07fa01589658$var$BOARD_SIZE; col += 1){
            if (firstState[row][col] !== secondState[row][col]) return false;
        }
        return true;
    }
}
$a5fd07fa01589658$exports = $a5fd07fa01589658$var$Game;


const $09e991522ca7e64e$var$game = new $a5fd07fa01589658$exports();
const $09e991522ca7e64e$var$button = document.querySelector(".button");
const $09e991522ca7e64e$var$scoreElement = document.querySelector(".game-score");
const $09e991522ca7e64e$var$startMessage = document.querySelector(".message-start");
const $09e991522ca7e64e$var$winMessage = document.querySelector(".message-win");
const $09e991522ca7e64e$var$loseMessage = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$cells = document.querySelectorAll(".field-cell");
function $09e991522ca7e64e$var$renderBoard() {
    const state = $09e991522ca7e64e$var$game.getState();
    state.flat().forEach((value, index)=>{
        const cell = $09e991522ca7e64e$var$cells[index];
        cell.className = "field-cell";
        cell.textContent = "";
        if (value !== 0) {
            cell.textContent = value;
            cell.classList.add(`field-cell--${value}`);
        }
    });
}
function $09e991522ca7e64e$var$renderScore() {
    $09e991522ca7e64e$var$scoreElement.textContent = $09e991522ca7e64e$var$game.getScore();
}
function $09e991522ca7e64e$var$renderMessages() {
    $09e991522ca7e64e$var$startMessage.classList.add("hidden");
    $09e991522ca7e64e$var$winMessage.classList.add("hidden");
    $09e991522ca7e64e$var$loseMessage.classList.add("hidden");
    switch($09e991522ca7e64e$var$game.getStatus()){
        case "idle":
            $09e991522ca7e64e$var$startMessage.classList.remove("hidden");
            break;
        case "win":
            $09e991522ca7e64e$var$winMessage.classList.remove("hidden");
            break;
        case "lose":
            $09e991522ca7e64e$var$loseMessage.classList.remove("hidden");
            break;
        default:
            break;
    }
}
function $09e991522ca7e64e$var$renderButton() {
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") {
        $09e991522ca7e64e$var$button.textContent = "Start";
        $09e991522ca7e64e$var$button.className = "button start";
    } else {
        $09e991522ca7e64e$var$button.textContent = "Restart";
        $09e991522ca7e64e$var$button.className = "button restart";
    }
}
function $09e991522ca7e64e$var$renderGame() {
    $09e991522ca7e64e$var$renderBoard();
    $09e991522ca7e64e$var$renderScore();
    $09e991522ca7e64e$var$renderMessages();
    $09e991522ca7e64e$var$renderButton();
}
$09e991522ca7e64e$var$button.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") $09e991522ca7e64e$var$game.start();
    else $09e991522ca7e64e$var$game.restart();
    $09e991522ca7e64e$var$renderGame();
});
document.addEventListener("keydown", (e)=>{
    if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
    switch(e.key){
        case "ArrowLeft":
            e.preventDefault();
            $09e991522ca7e64e$var$game.moveLeft();
            break;
        case "ArrowRight":
            e.preventDefault();
            $09e991522ca7e64e$var$game.moveRight();
            break;
        case "ArrowUp":
            e.preventDefault();
            $09e991522ca7e64e$var$game.moveUp();
            break;
        case "ArrowDown":
            e.preventDefault();
            $09e991522ca7e64e$var$game.moveDown();
            break;
        default:
            return;
    }
    $09e991522ca7e64e$var$renderGame();
});
$09e991522ca7e64e$var$renderGame();


//# sourceMappingURL=index.0a87c9d7.js.map
